export const blogItems = [
    { label: "blog list", link: `${process.env.PUBLIC_URL}/blog-list` },
    { label: "blog details", link: `${process.env.PUBLIC_URL}/blog-details` },
    { label: "leftsidebar", link: `${process.env.PUBLIC_URL}/blog-leftside` },
    { label: "rightsidebar", link: `${process.env.PUBLIC_URL}/blog-rightside` },
    { label: "details leftsidebar", link: `${process.env.PUBLIC_URL}/blog-left-sidebar` },
    { label: "details rightsidebar", link: `${process.env.PUBLIC_URL}/blog-right-sidebar` },
  ];

  export const otherPagesItems = [
    { label: "Sign In", link: `${process.env.PUBLIC_URL}/sign-in` },
    { label: "Sign Up", link: `${process.env.PUBLIC_URL}/sign-up` },
    { label: "Forget Password", link: `${process.env.PUBLIC_URL}/forget-password` },
    { label: "Thank You", link: `${process.env.PUBLIC_URL}/thank-you` },
    { label: "Review", link: `${process.env.PUBLIC_URL}/review` },
    { label: "FAQ", link: `${process.env.PUBLIC_URL}/faq` },
    { label: "Coming Soon", link: `${process.env.PUBLIC_URL}/coming-soon` },
    { label: "Download", link: `${process.env.PUBLIC_URL}/download` },
    { label: "Request Demo", link: `${process.env.PUBLIC_URL}/request` },
    { label: "404", link: `${process.env.PUBLIC_URL}/404` },
  ];